<template>
  <v-container>
    <Breadcrumbs :breadcrumbs="breadcrumbs" />
    <v-data-table
      :headers="headers"
      :items="list"
      class="elevation-1"
      hide-default-footer
      disable-pagination
    >
      <template v-slot:top>
        <template>
          <v-btn
            class="float-right mt-3 mr-3"
            color="primary"
            dark
            @click="addDialog = true"
            >New Publisher</v-btn
          >
        </template>
        <v-toolbar flat color="white">
          <v-toolbar-title>Publishers</v-toolbar-title>
          <v-divider class="mx-4" inset vertical></v-divider>
        </v-toolbar>
        <v-row class="ml-2 mr-2">
          <v-col cols="12" sm="6" md="2" class="pt-0 pb-0">
            <v-text-field
              v-model="filter_name"
              label="Publisher Name"
              outlined
              dense
              @keyup="searchFilter"
            ></v-text-field>
          </v-col>
        </v-row>
      </template>
      <template v-slot:[`item.publisherid`]="{ item }">
        {{ list .map(function (x) { return x.publisherid; }) .indexOf(item.publisherid) + 1 }}
      </template>
      <template v-slot:[`item.action`]="{ item }">
        <v-icon
          title="Edit"
          small
          class="mr-2"
          color="#1976D2"
          @click.stop="editItemMethod(item)"
        >
          mdi-pencil
        </v-icon>
        <v-icon
          title="Delete"
          small
          @click.stop="deleteItemMethod(item)"
          color="#FF5252"
        >
          mdi-delete
        </v-icon>
      </template>
    </v-data-table>
    <template>
      <div class="text-center">
        <v-pagination
          v-model="page"
          :length="PagesNumber"
          :total-visible="7"
          @input="changePage($event)"
        ></v-pagination>
      </div>
    </template>
    <AddPublisher :addDialog="addDialog" v-on:DialogClose="DialogClose($event)" />
    <EditPublisher :editDialog="editDialog" :editItem="editItem" v-on:DialogClose="DialogClose($event)" />
    <DeletePublisher :deleteDialog="deleteDialog" :deleteItem="deleteItem"  v-on:DialogClose="DialogClose($event)" />
  </v-container>
</template>
<script>
import Breadcrumbs from "@/components/Global/Breadcrumbs";
import AddPublisher from "@/components/Publishers/AddPublisher";
import EditPublisher from "@/components/Publishers/EditPublisher";
import DeletePublisher from "@/components/Publishers/DeletePublisher";
export default {
  data: () => ({
    breadcrumbs: [
      {
        text: "Dashboard",
        disabled: false,
        to: "/",
      },
      {
        text: "Publishers",
        disabled: true,
      },
    ],
    headers: [
      { text: "#", value: "publisherid" },
      { text: "Publishe Name", value: "publishername" },
      { text: "Action ", value: "action" },
    ],
    list: [],
    page: 1,
    PagesNumber: 0,
    pageUrl: 1,
    filter_name: "",
    addDialog: false,
    editDialog: false,
    deleteDialog: false,
    editItem: {},
    deleteItem: {},
  }),
  mounted() {
    this.getAllPublishers();
    this.filterStatmint = "&filter[publishername]=" + this.filter_name;
  },
  components: {
    Breadcrumbs, AddPublisher, EditPublisher, DeletePublisher,
  },
  methods: {
    getAllPublishers() {
      this.$store
        .dispatch(
          "GetFromAPI",
          "/admin/publisher?per_page=20&page=" + this.pageUrl + this.filterStatmint
        )
        .then((response) => {
          this.PagesNumber = response["data"]["meta"]["last_page"];
          this.list = response["data"]["data"];
        });
    },
    changePage(val) {
      this.pageUrl = val;
      this.getAllPublishers();
    },
    searchFilter() {
      this.pageUrl = 1;
      this.filterStatmint = "&filter[publishername]=" + this.filter_name;
      this.getAllPublishers();
    },
    editItemMethod(item) {
      this.editItem = { ...item };
      this.editDialog = true;
    },
    deleteItemMethod(item) {
      this.deleteItem = { ...item };
      this.deleteDialog = true;
    },
    DialogClose(val) {
      if (val == true) {
        this.getAllPublishers();
      }
      this.addDialog = false;
      this.editDialog = false;
      this.deleteDialog = false;
    },
  },
};
</script>